// @flow
export {
  TREE,
  BRANCH,
} from 'fc-model-soil-test-results'
